import React, { useState } from "react";

export default function CelsiusConversion(props) {
  const [unit, setUnit] = useState("scale");
  function convertCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  function convertFahrenheit(event) {
    event.preventDefault();
    setUnit("scale");
  }

  if (unit === "scale") {
    return (
      <div className="CelsiusConversion">
        <span className="current-temp">{props.fahrenheit}</span>
        <span className="unit">
          °F |{" "}
          <a href="/" onClick={convertCelsius}>
            °C
          </a>{" "}
        </span>
      </div>
    );
  } else {
    let celsius = ((props.fahrenheit - 32) * 5) / 9;
    return (
      <div className="CelsiusConversion">
        <span className="current-temp">{Math.round(celsius)}</span>
        <span className="unit">
          <a href="/" onClick={convertFahrenheit}>
            °F
          </a>{" "}
          | °C
        </span>
      </div>
    );
  }
}
